export default __webpack_public_path__ + "static/media/logo.886d7d29.svg";